"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(arg1, arg2) {
  var avgPaymentEqual = arg1.avgPayment === arg2.avgPayment;
  var fotEqual = arg1.fot === arg2.fot;
  var contributionEqual = arg1.contribution === arg2.contribution;
  var employees = arg1.employees === arg2.employees;
  var penetration = arg1.penetration === arg2.penetration;
  return avgPaymentEqual && fotEqual && contributionEqual && employees && penetration;
}